import { Supplier } from '../types/models'

export const suppliersToCoords = (suppliers: ReadonlyArray<Supplier>) => {
  return suppliers.map((supplier) => ({
    lat: supplier.latitude,
    lng: supplier.longitude,
  }))
}
